var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$options.name},[_c('v-card',[_c('wms-form',{attrs:{"wms-data":_vm.single,"is-edit":""},on:{"submit":_vm.onSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }